<template>
    <transition name="fade">
        <div class="create-design-container">
            <div class="main-container">
                <div class="close-icon" @click="$emit('close-design-pop')">
                    <Icon type="md-close"></Icon>
                </div>
                <div class="main-title">Quick Customization</div>
                <div class="sub-title">Please upload your fashion design draft to place an order quickly.</div>
                <div class="up-body">
                    <Upload
                        type="drag"
                        :action="upload_url"
                        :data="{ dir: 'template' }"
                        multiple
                        :before-upload="onBeforeUpload"
                        :show-upload-list="false"
                    >
                        <div class="upload-box">
                            <img
                                src="../assets/images/icon-upload-blue.png"
                                alt=""
                                class="up-icon"
                            />
                            <div class="up-main-text">Drop files here or click to upload</div>
                            <div class="up-sub-text">Image file upload is supported, including JPG, PNG, PSD, CDR, etc.</div>
                        </div>
                    </Upload>
                    <div class="up-file-list">
                        <div class="up-file-item" v-for="(item,index) in form_data.image_list" :key="index">
                            <!-- <img :src="item.raw|default_img" v-viewer /> -->
                            <template v-if="util.test_image(item.raw)">
                                <img :src="item.raw" alt="" style="object-fit:cover;" />
                            </template>
                            <template v-else>
                                <a :href="item.raw" target="_blank">
                                    <img :src="util.get_image_icon(item.raw)" alt="" style="object-fit:cover;" />
                                </a>
                            </template>
                            <img @click="deleteImage(index)" src="../assets/images/icon-close-circle.png" alt="" class="remove-icon">
                        </div>
                    </div>
                    <div class="bottom">
                        <Button class="next-btn" @click="onSave(false)">Next Step</Button>
                        <div class="advanced-btn" @click="onSave(true)">Bespoke Customization ></div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import { SaveDraft } from '@/api/index';
import { uploadFileToOSS } from "@/utils/oss";
import util from "@/utils/util";
import { driver } from 'driver.js';
import { mapState } from 'vuex';
export default{
    name:"CreateDesign",
    data(){
        return{
            util: util,
            upload_url: process.uniEnv.BASE_API + "/util/upload-image",
            uploading: false,
            uploadQueue:[],
            debounceTimer: null, // 防抖定时器
            debounceTime: 300, // 防抖时间（毫秒）
            image_list:[],
            is_click:false
        }
    },
    props:{},
    computed:{
        ...mapState({
            form_data:state=>state.design.form_data
        })
    },
    mounted(){
        this.$store.commit("design/clear");
        if(!localStorage.getItem('create_pop_guide')){
            this.startGuide();
            localStorage.setItem('create_pop_guide',1);
        }
    },
    methods:{
        startGuide(){
            const guide = driver({
                showProgress:true, //>显示步骤进度
                allowClose:false,   //>禁止点击外部关闭
                nextBtnText:"Next",
                prevBtnText:"Prev",
                doneBtnText:"Done",
                closeBtnText:"Close",
                steps: [
                    {
                        element: '.upload-box',
                        popover: {
                            title: 'Upload your design draft',
                            description: 'Drag and drop your design draft here or click to upload',
                            position: 'right'
                        }
                    },
                    {
                        element: '.next-btn',
                        popover:{
                            title:"Easy Mode",
                            description: 'Click "Next Step" to start the quick customization',
                            position: 'right'
                        }
                    },
                    {
                        element: '.advanced-btn',
                        popover:{
                            title:"Advanced Customization",
                            description: 'Click "Bespoke Customization" start the advanced customization',
                            position: 'right'
                        }
                    },
                ]
            })
            guide.drive();
        },
        async onSave(advanced){
            // TODO 保存,获取UUID,跳转新的SUMMARY
            try{
                if (this.is_click) {
                    return;
                }
                this.is_click = true;
                console.log('form_data',this.form_data,'typeof advanced:',typeof advanced);
                console.log('!advanced',!advanced);
                console.log('advanced-->',advanced);
                console.log('full-condition',!this.form_data.image_list.length && !advanced);
                if(!this.form_data.image_list.length && !advanced){
                    this.$layer.msg('Please upload image or file');
                    return;
                }
                // return;
                if(this.form_data.image_list.length){
                    const {data} = await SaveDraft({
                        ...this.form_data,
                        scene: "quick", //bc
                    })
                    if(!data.uuid){
                        this.$layer.msg('Operation failed,please try again later');
                        return;
                    }
                    this.$layer.msg('Operation successful,go to next step!');
                    setTimeout(()=>{
                        if(advanced){
                            this.$router.push({name:'WorkBenchDesign',query:{uuid:data.uuid,from:'draft'}});
                        }else{
                            this.$router.push({name:'QuickDesign',query:{uuid:data.uuid}})
                        }
                        this.$emit('close-design-pop');
                    },1500);
                    console.log('save-data',data);
                }else{
                    this.$router.push({name:'WorkBenchDesign'});
                    this.$emit('close-design-pop');
                }
                
            }catch(e){
                console.log('e',e);
            }finally{
                this.is_click=false;
            }
        },
        deleteImage(index){
            this.$store.commit('design/arr_remove_one', {key: 'image_list', index})
            let len = this.form_data.image_list.length;
            console.log(111, len)
            if (len === 0) {
                this.main_file = {raw: '', raw_name: ''}
            } else {
                if(typeof this.form_data.image_list[0] === 'object') {
                    this.main_file = this.form_data.image_list[0]
                } else {
                    this.main_file = {
                        raw: this.form_data.image_list[0],
                        raw_name: ''
                    }
                }
            }
        },
        async processAllFiles() {
            const queue = [...this.uploadQueue];
            this.uploadQueue = []; // 清空队列

            console.log(`Startting upload ${queue.length} files...`);

            for (const file of queue) {
                try {
                const url = await uploadFileToOSS(file, "template");
                // this.image_list.push({raw:url,raw_name:file.name});
                const object = {raw:url,raw_name:file.name};
                this.$store.commit('design/arr_push_one', {key: 'image_list', value: object})
                console.log('image_list',this.form_data.image_list);
                // console.log('this.image_list',this.image_list);
                } catch (err) {
                this.$layer.msg(`上传失败：${file.name}`);
                }
            }

        },
        onBeforeUpload(file) {
            console.log("file-before", file);
            this.uploading = true;
            // 将文件加入队列
            this.uploadQueue.push(file);

            // 清除旧定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }

            // 设置新定时器：如果一段时间内没有新文件进来，则认为上传完成
            this.debounceTimer = setTimeout(() => {
                this.processAllFiles();
            }, this.debounceTime);
            return false;
        },
    }
}
</script>
<style lang="scss" scoped>
 .create-design-container{
    width: 100%;
    height:100%;
    background:rgba(0,0,0,0.5);
    position:fixed;
    top:0;
    left:0;
    display:flex;
    align-items:center;
    justify-content:center;
    .main-container{
        width:930px;
        // height:727px;
        border-radius:10px;
        background:#ffffff;
        position:relative;
        .close-icon{
            position:absolute;
            top: 20px;
            right: 25px;
            cursor:pointer;
        }
        .main-title{
            width:100%;
            font-weight: bold;
            font-size: 20px;
            color: #000000;
            text-align: center;
            margin-top:31px;
            margin-bottom:13px;
        }
        .sub-title{
            width:100%;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            line-height: 20px;
            text-align: center;
        }
        .up-body{
            padding:20px 30px;
            .upload-box{
                width:100%;
                display:flex;
                align-items:center;
                justify-content:center;
                flex-direction:column;
                .up-icon {
                    width: 63px;
                    height: 46px;
                    margin-top:45px;
                    margin-bottom:20px;
                    animation: breathe 1s ease-in-out infinite;
                }
                .up-main-text{
                    color:#333333;
                    font-size:14px;
                    margin-bottom:11px;
                }
                .up-sub-text{
                    color:#999999;
                    font-size:12px;
                    margin-bottom:49px;
                }
            }
            .up-file-list{
                width:100%;
                height:auto;
                max-height:220px;
                overflow-y:auto;
                margin-top:30px;
                display:flex;
                align-items:center;
                flex-wrap:wrap;
                gap:10px;
                // margin-bottom:60px;
                // border-bottom:1px solid #ebebeb;
                &::-webkit-scrollbar{
                    display:none;
                }
                .up-file-item{
                    width:100px;
                    height:100px;
                    border-radius:5px;
                    border:1px solid #dbdbdb;
                    background:#f7f7f7;
                    position:relative;
                    img{
                        width:100%;
                        height:100%;
                        border-radius:5px;
                        object-fit:cover;    
                    }
                    .remove-icon{
                        width:22px;
                        height:22px;
                        position:absolute;
                        top:5px;
                        right:5px;
                    }
                }
            }
            .bottom{
                width:100%;
                margin-top:60px;
                border-top:1px solid #ebebeb;
                display:flex;
                align-items:center;
                justify-content:flex-end;
                column-gap:159px;
                .next-btn{
                    background: #fe5866;
                    color:#ffffff;
                    border:none;
                    width:200px;
                    height:42px;
                    margin-top:40px;
                    margin-bottom:30px;
                }
                .advanced-btn{
                    color:#666666;
                    font-size:14px;
                    margin-top:40px;
                    margin-bottom:30px;
                    cursor:pointer;
                }
            }
        }
        
    }
 }
 @keyframes breathe {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
 }
</style>